import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { ProductAssetsList } from 'src/app/models/product/productAssets.modal';
import { FileModel, UploadFileModel } from 'src/app/models/product/uploadFile.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-upload-product-image',
  templateUrl: './upload-product-image.component.html',
  styleUrls: ['./upload-product-image.component.css']
})
export class UploadProductImageComponent implements OnInit {
  Loader: boolean = false;
  productId: number;
  uploadFile: UploadFileModel;
  files: NgxFileDropEntry[] = [];
  fileModel: Array<FileModel> = new Array<FileModel>();
  uploadFileArray: Array<UploadFileModel> = new Array<UploadFileModel>();
  fileUrls: string[] = [];
  fileTitle: string[] = [];
  fileFormData: FormData[] = [];
  categoryList: any;
  allowedFiles: any;
  shortLink: string = "";
  productAssetsFullList: ProductAssetsList = new ProductAssetsList;
  fileType: string = "";
  productListing: any;
  uploadingFilesCount: number = 0;
  isShown: boolean = true;

  constructor(private localstorage: LocalstorageService, private _productService: ProductService, private alertify: AlertifyService, private route: Router, private modalService: NgbModal) {
    this.localstorage.setMenu("5");
    this.uploadFile = new UploadFileModel();

  }

  ngOnInit() {
    this._productService.getProductId.subscribe((selectedProductId: any) => {
      this.productId = +selectedProductId;
    });
    this._productService.getFileType.subscribe((fileType: any) => {
      this.fileType = fileType;
    });
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            let fileUploadModel = new FileModel();
            fileUploadModel.fileUrl.push(reader.result as string);
            this.fileUrls.push(reader.result as string);
            this.fileTitle.push(reader.result as string);
            var formData = new FormData();
            formData.append('Image', file, droppedFile.relativePath);
            this.fileModel.push(fileUploadModel);
            var uploadFile = new UploadFileModel();
            uploadFile.FileType = this.fileType;
            uploadFile.Image = file;
            uploadFile.ProductId = this.productId;
            uploadFile.ImageName = file.name;
            this.uploadFileArray.push(uploadFile)
          };

        });
      } else {
        this.alertify.error("Only files in " + this.allowedFiles + " format are accepted and directories are not allowed.");
      }
    }
  }
  fileOver(event) {
    console.log("File Over", event);
  }

  fileLeave(event) {
    console.log("File Leave", event);
  }

  onDelete(fileIndex) {
    this.fileModel.splice(fileIndex, 1);
    this.uploadFileArray.splice(fileIndex, 1);
    console.log(this.fileModel);
  }

  isFileAllowed(fileName: string) {
    let isFileAllowed = false;
    switch (this.fileType) {
      case '2':
        this.allowedFiles = ['.mp4', '.mpg', '.m4v', '.flv'];
        break;
      case '3':
        this.allowedFiles = ['.mp4', '.mpg', '.m4v', '.flv'];
        break;
      default:
        this.allowedFiles = ['.jpg', '.jpeg', '.png'];
        break
    }
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName);
    if (undefined !== extension && null !== extension) {
      for (const ext of this.allowedFiles) {
        if (ext === extension[0]) {
          isFileAllowed = true
        }
      }
    }
    return isFileAllowed;
  }

  onSubmit() {
    this.uploadingFilesCount = 0;
    //document.getElementById('delete').classList.toggle('show');
    this.Loader = true;
    this.isShown = false;
    this.uploadFileArray.forEach(file => {
      this._productService.uploadimage(file)
        .subscribe((rec) => {
          this.uploadingFilesCount++;
          if (this.uploadFileArray.length == this.uploadingFilesCount) {
            this.Loader = false
            this.modalService.dismissAll();
          }
        }, (err) => {
          this.Loader = false;
        });
    });
  }

  changeFileTile(title, index) {
    this.uploadFileArray[index].FileTitle = title;
  }
}